import React from 'react';
import { useParams } from 'react-router-dom';

// Hooks
import MovementProvider from '../../../hooks/movements/MovementProvider';
import useUser from '../../../hooks/user/useUser';

// Models
import { types, subTypes, states } from '../../../models/MovementEntity';

import MovementEdition from './main';

const MovementEditionView = () => {
    const user = useUser();
    const { movementId } = useParams();

    return (
        <MovementProvider 
            movement={
                { 
                    warehouseId: user.branch.warehouseId, 
                    type: types.Egress,
                    subType: subTypes.Transfer,
                    state: states.Pending,
                    branchCode: user.branch.code
                }
            }
        >
            <MovementEdition movementId={movementId} />
        </MovementProvider>
    )
}

export default MovementEditionView;